import React, { useEffect, useState } from 'react'
import './Header.css'
import { useHref, Link } from 'react-router-dom'
import { motion } from "framer-motion";


function Header({ login, logout, user }) {
    const [width, setWidth] = useState(window.innerWidth)
    const [openSidebar, setOpenSidebar] = useState(false)

    const href = useHref()

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });

        const header = document.querySelector('header');
        window.onscroll = function () {
            var top = window.scrollY;
            if (top >= 100) {
                header.classList.add('homepage_header_scrolled');
            } else {
                header.classList.remove('homepage_header_scrolled');
            }
        }


    }, [])

    useEffect(() => {
        let resizer = () => {
            setWidth(window.innerWidth)
        }
        window.addEventListener('resize', resizer)
        if (width > 600) {
            setOpenSidebar(false)
        }
        return () => {
            window.removeEventListener('resize', resizer)
        }
        // eslint-disable-next-line 
    }, [])

    const sidebar = () => {
        setOpenSidebar(prev => !prev)
    }



    return (
        <header className="homepage_header" >
            <div className='left_header'>
                <Link to="/" className="title">
                    {/* <img src="Images/tubelink-logo.png" alt="tubelink" />
                    <Link to='/'>TubeLink</Link> */}
                    <img src="Images/tubelink-logo-with-text-2.png" alt="tubelink" />
                </Link>

                <section className='left_header_section'>
                    <span><Link to="/pricing" >Pricing</Link></span>
                    {<span><Link to="/contact" >Contact</Link></span>}
                </section>
            </div>
            <div className='right_header'>
                {user && <div>
                    <div className='img_container'>
                        <img src={user.photoURL} alt='user profile' referrerPolicy="no-referrer" id="image" />
                        <span>
                            ↓
                        </span>
                    </div>
                    <div className='img_dropdown' id="dropdown" >
                        {width <= 600 && <>
                            <span><Link to='/pricing'>Pricing</Link></span>
                            <span><Link to='/contact'>Contact</Link></span>
                        </>}
                        <span><Link to='/profile'>Profile</Link></span>
                        <span onClick={() => { logout(); setOpenSidebar(false) }}>
                            Logout
                        </span>

                    </div>
                </div>}
                {width >= 600 && !user && <button className="get_started" onClick={() => login()}>Get started</button>}
                {width <= 600 && !user && <div className='burger' onClick={sidebar}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>}
                {!user && openSidebar && width <= 600 && <motion.div className='sidebar' initial={{ top: -240 }} animate={{ top: 80 }} transition={{ duration: 0.5 }}>
                    {href === "/" && <span onClick={() => login()}>Get Started</span>}
                    {href !== "/pricing" && <Link to="/pricing"><span>Pricing</span></Link>}
                    {href !== "/contact" && <Link to="/contact"><span>
                        Contact
                    </span></Link>}
                </motion.div>}
            </div>
        </header >
    )
}

export default Header